import React from 'react';
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
import Table from "nood-comp/src/comp/data/table/Table";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Row from "nood-comp/src/comp/ui/containers/flex-boxes/Row";
import { DateFormatter } from "nood-comp/src/util/converters/DateFormatter";
import CloudinaryImg from "nood-comp/src/comp/ui/image-viewer/CloudinaryImg";
import Circle from "nood-comp/src/comp/ui/circle/Circle";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import { NavLink } from "react-router-dom";
export default function Events(props) {
  return /*#__PURE__*/React.createElement(Table, {
    key: "table-events",
    useQuery: true,
    data_source: "/events",
    rowPadding: 5,
    paging: {
      per_page: 10,
      sorters: [{
        property: 'created_on',
        isAsc: false
      }]
    },
    cols: [{
      label: "Event",
      property: "title",
      icon: "menu",
      filterType: "text",
      filterPlaceholder: "Title",
      to: function to(obj, idx) {
        return queryStringMod({
          "do": "view",
          id: obj.id
        });
      },
      content: function content(obj, idx) {
        var _obj$poster, _obj$org, _obj$org2, _obj$org3, _obj$org4;
        return /*#__PURE__*/React.createElement(Row, {
          gap: 15,
          style: {
            padding: "10px",
            textDecoration: "none"
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CloudinaryImg, {
          filename: (_obj$poster = obj.poster) === null || _obj$poster === void 0 || (_obj$poster = _obj$poster.img) === null || _obj$poster === void 0 ? void 0 : _obj$poster.filename,
          resourceImageSize: "S",
          width: 100,
          height: 100,
          borderRadius: 15,
          style: {
            border: "1px solid var(--shade-10)"
          }
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, {
          secondary: true
        }, obj.kicker), /*#__PURE__*/React.createElement(Text, {
          size: 18,
          bold: true
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            display: "inline-flex",
            gap: 5
          }
        }, /*#__PURE__*/React.createElement("span", null, obj.title), /*#__PURE__*/React.createElement("span", null, obj.is_published ? /*#__PURE__*/React.createElement(Circle, {
          title: "Event is published",
          size: 10,
          backgroundColor: "#81be48"
        }) : /*#__PURE__*/React.createElement(Circle, {
          title: "Event is draft",
          size: 10,
          backgroundColor: "#9f9f9f"
        })))), obj.sub_title && /*#__PURE__*/React.createElement(Text, {
          secondary: true
        }, obj.sub_title), /*#__PURE__*/React.createElement(Row, {
          gap: 5
        }, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Flex, {
          gap: 5
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          icon: "calendar"
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
          color: "var(--text-error)"
        }, DateFormatter.format(obj.start_dt, DateFormatter.SQL_DATE, 'ddd, mmm d')))), /*#__PURE__*/React.createElement(Flex, {
          gap: 5
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
          icon: "map-pin"
        })), /*#__PURE__*/React.createElement("div", null, obj.is_online ? /*#__PURE__*/React.createElement(Text, {
          secondary: true
        }, "Online") : /*#__PURE__*/React.createElement(Text, {
          secondary: true
        }, obj.location))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Spacer, {
          mtop: 10
        })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Flex, {
          gap: 5,
          alignItems: 'top'
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NavLink, {
          to: "/orgs?do=view&id=".concat((_obj$org = obj.org) === null || _obj$org === void 0 ? void 0 : _obj$org.id)
        }, /*#__PURE__*/React.createElement(CloudinaryImg, {
          filename: (_obj$org2 = obj.org) === null || _obj$org2 === void 0 || (_obj$org2 = _obj$org2.logo) === null || _obj$org2 === void 0 ? void 0 : _obj$org2.filename,
          resourceImageSize: 'S',
          width: 20,
          height: 20
        }))), /*#__PURE__*/React.createElement(FlexVertical, {
          gap: 3
        }, /*#__PURE__*/React.createElement(NavLink, {
          to: "/orgs?do=view&id=".concat((_obj$org3 = obj.org) === null || _obj$org3 === void 0 ? void 0 : _obj$org3.id)
        }, /*#__PURE__*/React.createElement(Text, null, (_obj$org4 = obj.org) === null || _obj$org4 === void 0 ? void 0 : _obj$org4.username))))))));
      }
    }, {
      label: "",
      width: 70,
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          key: obj.id,
          datetime: obj.created_on
        });
      }
    }]
  });
}